import { ProductTypeUrlSuffix } from '../models/product-type-url-suffix';
/**
 * @internal
 */
export var getProductTypeUrlSuffix = function (productType) {
    var productTypeUrlSuffix;
    switch (productType) {
        case "g" /* Group */:
            productTypeUrlSuffix = ProductTypeUrlSuffix.Group;
            break;
        case "p" /* Product */:
            productTypeUrlSuffix = ProductTypeUrlSuffix.Product;
            break;
        case "f" /* Family */:
        default:
            productTypeUrlSuffix = ProductTypeUrlSuffix.Family;
            break;
    }
    return productTypeUrlSuffix;
};
